import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Input, Modal, Form, Checkbox, Button, Row, Col, message } from 'antd';
import withRoleAccess from '../../hoc/withRoleAccess';

const SubjectModal = ({ isOpen, onClose, onSave, subjectData }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (subjectData) {
      form.setFieldsValue({ ...subjectData });
    } else {
      form.resetFields();
    }
  }, [subjectData, form, isOpen]);

  const handleFinish = async (values) => {
    setLoading(true);
    try {
      await onSave(values);
      message.success(t('changesSaved'));
      form.resetFields();
      onClose();
    } catch (err) {
      message.error(t('errorSavingSubject'));
      console.error('Error saving subject:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={subjectData ? t('editSubject') : t('createSubject')}
      open={isOpen}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          {t('cancel')}
        </Button>,
        <Button 
          key="submit" 
          type="primary" 
          onClick={() => form.submit()}
          loading={loading}
        >
          {t('save')}
        </Button>
      ]}
      width={600}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item 
              name="subjectgroup" 
              label={t('subjectGroup')}
              rules={[{ required: true, message: t('pleaseEnterSubjectGroup') }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item 
              name="code" 
              label={t('code')}
              rules={[{ required: true, message: t('pleaseEnterCode') }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item 
              name="year" 
              label={t('year')}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item 
              name="level" 
              label={t('level')}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item 
          name="title" 
          label={t('subjecttitle')}
          rules={[{ required: true, message: t('pleaseEnterTitle') }]}
        >
          <Input />
        </Form.Item>

        <Form.Item 
          name="specification" 
          label={t('specification')}
        >
          <Input />
        </Form.Item>

        <Form.Item 
          name="description" 
          label={t('description')}
        >
          <Input.TextArea rows={3} />
        </Form.Item>

        <Form.Item 
          name="image_url" 
          label={t('imageUrl')}
        >
          <Input placeholder="https://..." />
        </Form.Item>

        <Form.Item 
          name="language" 
          label={t('languages')}
        >
          <Checkbox.Group style={{ width: '100%' }}>
            <Row>
              <Col span={12}>
                <Checkbox value="Thai">Thai</Checkbox>
              </Col>
              <Col span={12}>
                <Checkbox value="English">English</Checkbox>
              </Col>
            </Row>
          </Checkbox.Group>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default withRoleAccess(SubjectModal, ['admin', 'superadmin']);